var React = require('react');

function Minus (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm-4.166-9.165h8.333V9.167H5.834v1.668Z","clipRule":"evenodd"}));
}

Minus.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = Minus;

Minus.default = Minus;
